import React from 'react'
import cls from '@UI/crypto_exchange/desktop/components/modals/ProblemGamblerModal/ProblemGamblerModal.module.scss'

interface Props {
  closeModal: () => void
}

const StepSuccess: React.FC<Props> = ({ closeModal }) => (
  <div className={`${cls.step} ${cls.success}`}>
    <div className={cls.modalHeader}>
      <div className={cls.title}>{'Thank you for helping us to make CFD a better place and good luck!'}</div>
    </div>
    <div className={cls.text}>
      <div>
        <div>
          In accordance with the Responsible Gaming Policy and in compliance with the Gambling Commission's Remote
          Technical Standards and LCCP you may define personal limits as following:
        </div>
        <div>
          {' '}
          -<b>Set a limit on the amount you may deposit over a specified period of time</b>
          <br /> <em>A deposit limit controls how much money the player may deposit per day, week, or month</em>
        </div>
        <div>
          {' '}
          -<b>Set a limit on the amount you may spend over a specified period of time</b>
          <br /> <em>A stake limit controls how much money the player may stake per day, week, or month</em>
        </div>
        <div>
          {' '}
          -<b>Set a limit on the amount you may lose over a specified period of time</b>
          <br /> <em>A loss limit controls how much money the player may lose per day, week, or month</em>
        </div>
        <div>
          {' '}
          Should you request any assistance with personal limits you are urged to contact our customer service team via
          email at <a href="mailto:support@cfd.vip">support@cfd.vip</a>.
        </div>
      </div>
    </div>
    <div className={cls.actions}>
      <button onClick={closeModal} className={cls.button}>
        Continue
      </button>
    </div>
  </div>
)

export default StepSuccess
